import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TabHeader from './header';
import TabPanel from './panel';

class Tab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: props.defaultIndex
        };
        this.changeState = this.changeState.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps.defaultIndex, this.state.index);
        if (nextProps.defaultIndex != this.state.index) {
            this.setState({
                index: nextProps.defaultIndex
            });
        }
    }

    getChildContext() {
        const { index } = this.state;
        return {
            index,
            changeState: this.changeState
        };
    }

    changeState(key, value) {
        const { onChange } = this.props;
        this.setState({ [key]: value });
        if (key == 'index') {
            onChange && onChange(value);
        }
    }

    render() {
        const { children, className } = this.props;
        return (
            <div className={className}>
                {children}
            </div>
        );
    }
}
Tab.childContextTypes = {
    index: PropTypes.number,
    changeState: PropTypes.func
};
Tab.propTypes = {
    onChange: PropTypes.func,
    defaultIndex: PropTypes.number
};
Tab.defaultProps = {
    defaultIndex: 0
};
export { TabHeader };
export { TabPanel };
export default Tab;



// WEBPACK FOOTER //
// ./client/component/tab/index.js